import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ILsData, LsSchemaType } from '../../shared/models/ls.model';
import { LsSchemas } from '../../shared/models/lsSchemas';
import { AccountService } from '@easy-lib/modules/account-activity';

import { convertToPersianText, DateHelper } from '@easy-lib/tools';
import { BaseService, SymbolService } from '@easy-lib/modules/shared/services';
import { LsService, NotificationService, UserDeviceService } from '../../shared/services';
import { AuthService } from '../../authentication';
import { BaseMessage, LsMessage, MarketMessage } from '../models/message.model';
import { changeMsgBodyStyle, typeExtractor } from './message.tools';

@Injectable({
	providedIn: 'root'
})
export class BaseMessageService extends BaseService {
	lsService: LsService = inject(LsService);
	accountService: AccountService = inject(AccountService);
	authService: AuthService = inject(AuthService);
	notifyService: NotificationService = inject(NotificationService);
	symbolService: SymbolService = inject(SymbolService);
	userDeviceService: UserDeviceService = inject(UserDeviceService);
	private messagesLsSubject = new BehaviorSubject<LsMessage>(new LsMessage());
	textMessages$ = this.messagesLsSubject.asObservable();

	get messagesStorageKey(): string {
		return 'messages-' + this.accountService?.userAccountInfo?.value?.customerIsin;
	}

	constructor() {
		super();
		this.subscribeToTextMessage();
		this.lsService.resetLsManually$.pipe(filter(res => res)).subscribe(() => {
			this.subscribeToTextMessage();
		});
	}

	subscribeToTextMessage() {
		this.lsService
			.subscribeToLs(LsSchemaType.TextMessage)
			.pipe(
				filter((data: ILsData) => data.name === LsSchemas.orderStateNewSchema.meta),
				map((data: ILsData) => <LsMessage>JSON.parse(data.val))
			)
			.subscribe(msg => this.messagesLsSubject.next(msg));
	}

	msgTitleFix(title: string) {
		title = convertToPersianText(title);
		title = this.normalTitleSymbolName(title);
		return title.replace('<SUITE>', '');
	}
	normalTitleSymbolName(title: string) {
		let fixedTitle = title;
		const regexp = /\(([^)]+)\)/g;
		const matches = title.match(regexp);
		if (matches) {
			const data: string[] = [];
			for (const t of matches) {
				if (t.match(/[\d-]/)) {
					const symbol = this.symbolService.symbolByName[t.slice(1, -2)];
					if (symbol) data.push('(' + symbol.symbolName + ')');
					else data.push(t);
				} else data.push(t);
			}
			matches.forEach((t, index) => {
				fixedTitle = fixedTitle.replace(t, data[index]);
			});
		}
		return fixedTitle;
	}
	prepareMessageDetail(msg: LsMessage): BaseMessage {
		const message = new MarketMessage();
		message.date = DateHelper.getDateWithTimeFromNumber(msg.Timestamp.toString());
		message.title = this.msgTitleFix(msg.Title);
		message.body = convertToPersianText(msg.Body);
		message.id = msg.Id ?? msg.MessageId;
		message.isins = msg?.Isin?.split(',');
		message.isRead = false;
		message.createDateTime = DateHelper.getDateWithTimeFromNumber(msg.Timestamp.toString());
		message.type = msg?.Type;
		message.contentType = typeExtractor(message.title);
		message.isEnabled = msg.IsEnabled ?? true;
		return message;
	}
	prepareMofidMessageDetail(msg: LsMessage): BaseMessage {
		const message = new BaseMessage();
		message.date = DateHelper.getDateWithTimeFromNumber(msg.Timestamp.toString());
		message.title = this.msgTitleFix(msg.Title);

		message.body = changeMsgBodyStyle(convertToPersianText(msg?.Body ?? ''));
		message.id = msg.Id ?? msg.MessageId;
		//message.isins = msg?.Isin?.split(',');
		message.isRead = false;
		// message.seenTime = null;
		message.createDateTime = DateHelper.getDateWithTimeFromNumber(msg.Timestamp.toString());
		message.type = msg?.Type;
		return message;
	}
}
